/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Referral Agent update request(null values ignored)
 */
export interface ReferralAgentUpdateRequest {
  referralAgentId: number;
  name?: string;
  /**
   * Commission rate must be >= 0 and <= 1
   */
  commissionRate?: number;
}
